var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rich-text-viewer",class:{ 'is-fullscreen': _vm.isFullscreen }},[_c('div',{staticClass:"ql-container ql-snow",style:(_vm.boxBorder ? {} : { border: 'none' })},[_c('div',{ref:"contentRef",staticClass:"ql-editor"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }